export const API_ENDPOINT = {
  login: 'v2/login',
  forgot_password_otp_resquest: 'v2/forgetpassword',
  forgot_password_otp_resend: 'v2/resendforgetotp',
  forgot_password_otp_verify: 'v2/forgetotpverify',
  password_reset: 'v2/setnewpassword',
  register: 'v2/register',
  register_otp_verify: 'v2/signupotpverify',
  register_otp_resend: 'v2/resendsignupotp',
  getFullLocation: 'v2/getfulllocation',
  getLocationWithStateCountry: 'v2/getlocations',
  getSkills: 'v2/getskill',
  getJobTitle: 'v2/getjobtitle',
  employmentType: 'v2/employmenttypedropdown',
  masterData: 'v2/masterdropdown',
  workVisa: 'v2/workvisadropdown',
  getCurrencyOpt: 'v2/getcurrencies',
  roleData: 'v2/roledropdown',
  getCompany: 'v2/getcompany',
  tags: 'v2/emp/tags',
  getCountry: 'v2/countrydropdown',
  getState: 'v2/statedropdown',
  getCity: 'v2/citydropdown',
  getDomain: 'v2/domaindropdown',
  changePassword: 'v2/changepassword',
  getEducation: 'v2/geteducation',
  contactUS: 'v2/contactus',
  homePage: 'v2/homepage',
  searchJob: 'v2/jobsearch',
  appliedJob: 'v2/appliedjob',
  employerViewed: 'v2/employerviewed',
  savedJob: 'v2/savedjob',
  dashboard: 'v2/homepage2',
  headerCount: 'v2/headercount',
  viewJob: 'v2/viewjob',
  fetchChatList: 'v2/fetchChatList',
  fetchChat: 'v2/fetchChat',
  sendChatMessage: 'v2/msg2rec',
  fetchRecruiter: 'v2/fetchrecruiter',
  blockRecruiter: 'v2/blockrecruiter',
  unBlockRecruiter: 'v2/unblockrecruiter',
  fetchSubscription: 'v2/fetchsubscription',
  updateSubscription: 'v2/updatesubscription',
  fetchProfile: 'v2/fetchprofile',
  jobAlert: 'v2/jobalert',
  updateSkill: 'v2/updateskill',
  deleteSkill: 'v2/deleteskill',
  likeJob: 'v2/likejob',
  saveJob: 'v2/savejob',
  updateSkills2: 'v2/updateprofileskill2',
  updateWorkExp: 'v2/updateworkexp',
  updateMoreWorkExp: 'v2/updatemoreworkexp',
  updateEducation: 'v2/updateeducation',
  updateCertification: 'v2/updatecertification',
  updateProject: 'v2/updateproject',
  updateCompensation: 'v2/updatecompensation',
  updateReference: 'v2/updaterefrence',
  updateCurrentLocation: 'v2/updateaddress',
  updatePersonalInformation: 'v2/updateprofile',
  updateSocialMedia: 'v2/updatesocialmedia',
  updateEmail: 'v2/updateemail',
  deleteEducation: 'v2/deleteeducation',
  deleteMoreWorkExp: 'v2/deletemoreworkexp',
  deleteCertification: 'v2/deletecertification',
  deleteProject: 'v2/deleteproject',
  profileActivation: 'v2/profileactivation',
  fetchProfileStatus: 'v2/fetchprofilestatus',
  updateVideo: 'v2/updateprofilevideo',
  updateProfilePic: 'v2/updateprofilepic',
  applyJob: 'v2/applyjob',
  fetchJobComment: 'v2/fetchjobcomment',
  jobComment: 'v2/jobcomment',
  deleteVideo: 'v2/deletevideo',
  applyNoLogin: 'v2/applynologin',
  updateResumeAndApply: 'v2/updateResumeAndApply',
  skipsignupotpverify: 'v2/skipsignupotpverify',
  reSendSignupOTP: 'v2/resendsignupotp_postlogin',
  signupOTPVerify: 'v2/signupotpverify_postlogin',
  deleteProfile: 'v2/deleterequest',
  validateAccount: 'v2/validate-account',
  validateEmailChange: 'v2/validate-email-change',
  validateInterviewResponse: 'v2/validate-interview-response',
  fetchSubscription2: 'v2/fetchsubscription2',
  updateSubscription2: 'v2/updatesubscription2',
  getBlog: 'v2/blocksearch',
  getFAQ: 'v2/faqsearch',
  resumeBase64: 'v2/downloadresume',
  markAsReadMSG: 'v2/updatecountmessagecandidate',
  deleteProfilePic: 'v2/deleteprofilepic',
  verifyEmailPhone: 'v2/registercheck',
  resumeParsing: 'v2/resumeparse',
  getPreSignedUrl: 'v2/getpresignurl'
};
